import type { ISHISession, Nullable } from '@nib/types-session-api';
import { createSlice, SerializedError } from '@reduxjs/toolkit';
import { initSession, saveSession } from './thunks';

/**
 * https://redux-toolkit.js.org/api/createslice
 */

export interface SessionState {
  session: Nullable<ISHISession>;
  loading: 'idle' | 'pending' | 'fulfilled' | 'rejected';
  fetched: boolean;
  error: Nullable<SerializedError>;
}

const initialState: SessionState = {
  session: null,
  loading: 'idle',
  fetched: false,
  error: null,
} as const;

// Then, handle actions in your reducers:
const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(initSession.pending, (state) => {
      state.loading = 'pending';
      state.error = null;
    });

    builder.addCase(initSession.fulfilled, (state, action) => {
      state.session = action.payload;
      state.loading = 'fulfilled';
      state.fetched = true;
    });

    builder.addCase(initSession.rejected, (state, action) => {
      state.error = action.error;
      state.loading = 'rejected';
    });

    builder.addCase(saveSession.pending, (state) => {
      state.loading = 'pending';
      state.error = null;
    });

    builder.addCase(saveSession.fulfilled, (state, action) => {
      state.session = action.payload;
      state.loading = 'fulfilled';
    });

    builder.addCase(saveSession.rejected, (state, action) => {
      state.error = action.error;
      state.loading = 'rejected';
    });
  },
});

export default sessionSlice.reducer;
